import { render, staticRenderFns } from "./nav-left-sub.vue?vue&type=template&id=e21a7f7a&scoped=true&"
import script from "./nav-left-sub.vue?vue&type=script&lang=ts&"
export * from "./nav-left-sub.vue?vue&type=script&lang=ts&"
import style0 from "./nav-left-sub.vue?vue&type=style&index=0&id=e21a7f7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21a7f7a",
  null
  
)

export default component.exports